/*
 * Copyright (c) 2022, University of Oxford
 */
/**
 * Build a CSV data URI with UTF-8 BOM so Excel opens non-ASCII correctly.
 *
 * @param {string} content - CSV string content
 * @returns {string} data URI suitable for download links
 */
export const toDataURI = (content) => {
  return 'data:text/csv;charset=utf-8,' +
    // Add the byte order mark for Excel
    '\ufeff' +
    content
}
